import { createFileRoute } from "@tanstack/react-router";
import ThankYouExistingPatient from "@/pages/ThankYouExistingPatient";
export const Route = createFileRoute("/thank-you-existing-patient")({
  component: RouteComponent,
  head() {
    return {
      meta: [
        { name: "robots", content: "noindex, follow" },
        {
          title: "Thank You — Benefits Check Requested | Neuro Wellness",
        },
        {
          name: "description",
          content:
            "Thank you for requesting a benefits check. A care coordinator will reach out within one business day to verify your coverage and schedule your next visit.",
        },
        {
          property: "og:title",
          content: "Thank You — Benefits Check Requested | Neuro Wellness",
        },
        {
          property: "og:description",
          content:
            "Thank you for requesting a benefits check. A care coordinator will reach out within one business day to verify your coverage and schedule your next visit.",
        },
        {
          property: "og:url",
          content: "https://neurowellnesstms.com/thank-you-existing-patient",
        },
        {
          property: "og:type",
          content: "website",
        },
        {
          name: "twitter:card",
          content: "summary_large_image",
        },
      ],
      links: [
        {
          rel: "canonical",
          href: "https://neurowellnesstms.com/thank-you-existing-patient",
        },
      ],
    };
  },
});
function RouteComponent() {
  return <ThankYouExistingPatient />;
}
